import { render, staticRenderFns } from "./TqQuestExploreHeader.vue?vue&type=template&id=1522253b&scoped=true&"
import script from "./TqQuestExploreHeader.vue?vue&type=script&lang=js&"
export * from "./TqQuestExploreHeader.vue?vue&type=script&lang=js&"
import style0 from "./TqQuestExploreHeader.vue?vue&type=style&index=0&id=1522253b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522253b",
  null
  
)

export default component.exports